import { countryList } from '../constants/countries';
import { STATE_LIST_COUNTRY_CODES } from '../constants/states';

export const getCountryNameByTwoDigits = (digitCode: string) => {
  return countryList.find((el) => el.two_digit_code === digitCode);
};

export const isStateRequired = (country?: string | null): boolean => STATE_LIST_COUNTRY_CODES.includes(country ?? '');

export const isKnownCountryCode = (country?: string | null): boolean => {
  const code = (country ?? '').trim();
  return code.length > 0 && countryList.some((item) => item.two_digit_code === code);
};

export const toCountryCode = (country?: string | null): string => {
  const code = (country ?? '').trim();
  return isKnownCountryCode(code) ? code : '';
};

export const getRequiredFieldsByCountryCode = <T>(
  country: string | undefined,
  fieldsWithState: T,
  defaultFields: T,
): T => (isStateRequired(country) ? fieldsWithState : defaultFields);
